import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-mastercard-payment',
  standalone: true,
  templateUrl: '../../assets/mastercard-payment.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamMastercardPaymentIcon {}
